import React, { useMemo, useEffect } from "react";
import { ChoiceBox } from "@dishopsaas/design-system";
import { getAddressFormatted } from "../../../utils";
import getStyles from "../AddressInput.styles";
import { ShopsDropdownListProps } from "../../../1_types/AddressInputTypes";
import { STATUS } from "../../../constants/addressInput";
import Spinner from "../../Spinner";
import { Typography } from "@mui/material";
import { useAppSelector } from '../../../redux/hook';

export default function ShopsDropdownList({
  showShopsDropdownList,
  openShopsDropdownList,
  hasErrorAddressMessage,
  errorMessage,
  getShopsIsLoading,
  shopDropdowListText,
  closestShops,
  orderType,
  handleShopSelection,
}: ShopsDropdownListProps) {
  const baseOptions = useMemo(() => {
    if (!closestShops) return [];

    return (Array.isArray(closestShops) ? closestShops : [])
      .map((shop, key) => {
        const { name, distance, shopId, closed } = shop;
        const isClosedShop = typeof closed === "string";

        return {
          id: shopId || key,
          title: name,
          distanceKm: distance?.toFixed(2),
          address: getAddressFormatted(shop?.address),
          status: isClosedShop ? STATUS.CLOSED : STATUS.OPEN,
          outlined: isClosedShop,
        };
      })
      .filter(Boolean);
  }, [closestShops, orderType]);
  const showError =
    !openShopsDropdownList &&
    !hasErrorAddressMessage &&
    errorMessage &&
    !getShopsIsLoading;
  const styles = getStyles()

  const { shopId } = useAppSelector((state) => state.pendingOrderReducer);

  useEffect(() => {
    if (shopId) handleShopSelection(shopId);
  }, [shopId]);

  return (
    showShopsDropdownList() && (
      <div>
        {getShopsIsLoading && (
          <div style={styles.loadingContainer}>
            <Spinner />
          </div>
        )}

        {!getShopsIsLoading && baseOptions.length > 0 && (
          <>
            <Typography
              variant="body1"
              sx={{ ...styles.label, padding: "0px 0px 8px 0px" }}
            >
              Restaurants à proximité
            </Typography>
            <div style={styles.choicesContainer}>
              <ChoiceBox
                options={baseOptions}
                selectionMode="single"
                onChange={(value: any) => handleShopSelection(value[0])}
                value={[shopDropdowListText]}
              />
            </div>
          </>
        )}
        {showError && (
          <Typography variant="body1" sx={styles.errorText}>
            {errorMessage}
          </Typography>
        )}
      </div>
    )
  );
}
